// extracted by mini-css-extract-plugin
export var aboveInput = "_im-0";
export var actionButton = "_im-5";
export var actionButtonContainer = "_im-1";
export var actionIcon = "_im-6";
export var aiInfoContainer = "_im-2";
export var attachmentWrapper = "_im-7";
export var bold = "_im-3";
export var checkIcon = "_im-8";
export var clickingRecipientBar = "_im-11";
export var commentThreadSwitch = "_im-a";
export var draftImage = "_im-b";
export var draftImageContainer = "_im-c";
export var draftImages = "_im-e";
export var editButton = "_im-g";
export var editor = "_im-f";
export var editorContainer = "_im-y";
export var editorErrorTooltipWrapper = "_im-9";
export var headerDivider = "_im-h";
export var icon = "_im-i";
export var info = "_im-j";
export var internal = "_im-n";
export var internalDivider = "_im-k";
export var internalMessage = "_im-l";
export var messageInputCard = "_im-m";
export var messageInputForm = "_im-o";
export var messageInputFormInternal = "_im-p";
export var options = "_im-q";
export var publicMessageCustomer = "_im-s";
export var publicMessageMerchant = "_im-r";
export var removeImageButton = "_im-d";
export var replyButtons = "_im-t";
export var showSignatureButton = "_im-u";
export var spinner = "_im-v";
export var verticalButtonDivider = "_im-4";
export var visibilitySelector = "_im-w";
export var warning = "_im-x";
export var wrappingText = "_im-z";
export var writingInternalNoteTopBorder = "_im-10";